export default __webpack_public_path__ + "static/media/Our-Services2.eedb98b7.png";